import * as React from 'react';
import {Text, View} from 'react-native';

import {useStyles} from '../../../hooks/styles';
import {useTheme} from '../../../theme';
import {ExclamationInCircle} from '../../explamationInCircle';

export default () => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      ...theme.snackbar.colors.error,
    },
    wrapper: {
      height: 36,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    text: {
      ...theme.fonts.label,
      color: theme.color.whiteTextColor,
      textTransform: 'uppercase',
      marginLeft: 12,
    },
  }));
  return (
    <View style={styles.container}>
      <View style={styles.wrapper}>
        <ExclamationInCircle
          backgroundColor={theme.color.whiteTextColor}
          color={theme.snackbar.colors.error.backgroundColor}
        />
        <Text style={styles.text}>ИНТЕРНЕТ-СОЕДИНЕНИЕ НЕДОСТУПНО</Text>
      </View>
    </View>
  );
};
